import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material'
import { IOrder } from '../../types/order'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import useAxios from '../../hooks/useAxios'

interface Props {
  order?: IOrder | null
  isOpen: boolean
  onClose?: () => void
  title: string
}

interface timeline {
  trackingNumber: string
  trackingRecentNumber: string
  trackingDate: Date
  trackingStatusMessage: string
  trackingStatusMessageDesc: string
}

const TrackingTimelineModal = (props: Props) => {
  const { order, isOpen, onClose, title } = props
  const trackings = order?.trackings
  const code = order?.trackingCode ?? ''
  const provider = order?.trackingProvider ?? ''

  const { data, isLoading } = useAxios<timeline[]>({
    method: 'GET',
    url: `/trackings/${provider?.toLowerCase()}/status/${code}`,
  })

  if (!order || isLoading) {
    return <></>
  }

  const timelines = !isEmpty(data) ? data : trackings

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => onClose?.()}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '640px!important',
          },
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box className={'tab-tracking'}>
            <ul>
              {timelines?.map((tracking, index) => {
                return (
                  <li>
                    <div className="date">
                      {dayjs(tracking.trackingDate).format(
                        'DD/MM/YYYY HH:mm:ss',
                      )}
                    </div>
                    <div className="icon"></div>
                    <div className="desc">
                      <span className="code">
                        {tracking.trackingStatusMessageDesc
                          ? `${tracking.trackingStatusMessageDesc} - ${tracking.trackingStatusMessage}`
                          : tracking.trackingStatusMessage}
                      </span>
                      {/* <div className="code">{tracking?.trackingNumber}</div> */}
                      {!isEmpty(tracking?.trackingRecentNumber) && (
                        <div className="code">
                          {tracking?.trackingRecentNumber}
                        </div>
                      )}
                    </div>
                  </li>
                )
              })}
            </ul>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default TrackingTimelineModal
